import { checkAuth } from '@/apis';
import { EasyDrawContext } from '@/store';
import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import './styles.less';

export default observer(function NoNeedPermissionLayout() {

  const store = useContext(EasyDrawContext)

  useEffect(() => {
    checkAuth().then(res => {
      const { data = {} } = res
      if (data.valid) {
        store.userStore.queryUserInfo()
      }
    })
  }, [])
  return (
    <Layout className="diagram-app-wrapper">
      <Outlet />
    </Layout>
  );
})

